import { Component, forwardRef, HostBinding, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-d-date',
  templateUrl: './d-date.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DDateComponent),
      multi: true
    }
  ]
})
export class DDateComponent extends DynamicComponentBase {
  static KEY = 'd-date';

  // @HostBinding('style.float') float = 'left';

  constructor() {
    super();
  }
  dateFormat = 'yyyy-MM-dd';

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.allowClear !== 'boolean') {
      config.allowClear = true;
    }
    // config.value = '2021-12-12';
    // if (config.value) {
    //   config.value = new Date();
    //   console.log(config.value, ' config.value');
    // }
  }
}
